import React from "react";
import Screenshot from "../imgs/cairtean.png";

export const Cairtean = () => {
  return (
    <div className="itemContainer">
      <div className="itemContained">
        <img
          src={Screenshot}
          alt="Cairtean"
          className="screenshot"

        />
      </div>
      <div
        className="itemContained itemExplainer"
      >
        <center>
          <span className="itemTitle">Cairtean</span>
          <br />
          <br />

          <span className="itemBody">
            A flashcard app, using a spaced-repition algorithm to maximise efficiency
          </span>
        </center>
      </div>
    </div>
  );
};
